var en_BORK = {};
module['exports'] = en_BORK;
en_BORK.title = "English (Bork)";
en_BORK.lorem = require("./lorem");